import { sidebarConstant } from '../constants'
const initialState = {
  employeePermissions: {},
  permissionMetadata: {}
};
export default function (state = initialState, action = '') {
  const { type, payload } = action;
  switch (type) {
    case sidebarConstant.GET_EMPLOYEE_PERMISSION_SUCCESS:
      return {
        ...state,
        employeePermissions: payload,
      };
    case sidebarConstant.GET_EMPLOYEE_PERMISSION_METADATA:
      return {
        ...state,
        permissionMetadata: payload,
      };
    default:
      return state;
  }
}

